module.exports = __webpack_public_path__ + "img/jd_logo.4065c6c1.jpg";